import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {issuesAppBuilder} from './config/app-builder'

import {issuesLayoutRoute} from './routes/issues-layout-route'
import {IssuesLayout} from './routes/IssuesLayout'
import {labelsRoute} from './routes/labels-route'
import {Labels} from './routes/Labels'
import {labelsLegacyRedirectLoader} from './routes/labels-legacy-redirect-loader'

// The loader always redirects, so nothing is ever shown here. But React Router still
// renders the matched route and warns if a leaf route has no Component. this
// fails the tests (vitest-fail-on-console), so we pass an empty component
const LabelsRedirectFallback = () => null

export const issuesApp = issuesAppBuilder.createDataRouterAppFromRoutes([
  issuesLayoutRoute.toRoute({
    Component: IssuesLayout,
    children: [
      labelsRoute.toRoute({Component: Labels}),
      // defining it as a plain object because its just a legacy-redirect path
      {path: '/:owner/:repo/issues/labels', loader: labelsLegacyRedirectLoader, Component: LabelsRedirectFallback},
    ],
  }),
])
registerDataRouterApp(issuesApp)
